import React, { useState, useEffect } from "react";
import api from "../../api";
const baseURL=process.env.REACT_APP_BASE_URL;
export default function UpdateHotspotImg() {
  const [chapterNumber, setChapterNumber] = useState("");
  const [subchapterNumber, setSubchapterNumber] = useState("");
  const [imageNumber, setImageNumber] = useState("");
  const [subchapter, setSubchapter] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [hotspots, setHotspots] = useState([]);

  // 🔹 Fetch image with hotspots
  const handleFetch = async () => {
    if (!chapterNumber || !subchapterNumber || !imageNumber) {

      setError("Please fill all fields!");
      return;
    }
    try {
      setLoading(true);
      setError("");
      const res = await api.get(
        `/api/admins/subchapter/image-with-hotspots/${chapterNumber}/${subchapterNumber}/${imageNumber}`
      );
      console.log(imageNumber);
      setSubchapter(res.data);
      setHotspots(res.data.hotspots || []);
    } catch (err) {
      console.error("❌ Error fetching image:", err);
      setError("Image not found or failed to load.");
      setSubchapter(null);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Save updated hotspots
  const handleSave = async () => {
    if (!subchapter?.id) {
      alert("No subchapter found to update!");
      return;
    }

    try {
      setSaving(true);
      await api.put(
        `/api/admins/subchapter/${chapterNumber}/${subchapterNumber}/image-with-hotspots/${imageNumber}`,
        hotspots
      );
      console.log(imageNumber);
      alert("✅ Hotspots updated successfully!");
    } catch (err) {
      console.error("Error updating hotspots:", err);
      alert("❌ Failed to update hotspots!");
       console.log(imageNumber);
    } finally {
      setSaving(false);
    }
  };

  // 🔹 Handle hotspot updates
  const handleHotspotsChange = (updatedHotspots) => {
    setHotspots(updatedHotspots);
  };

  return (
    <div className="container mt-4">
      <h2 className="fw-semibold mb-4 text-center">🩺 Update Hotspot Image</h2>

      {/* Step 1: Input section */}
      {!subchapter && (
        <div className="card p-4 mx-auto" style={{ maxWidth: "400px" }}>
          <div className="mb-3">
            <input
              type="number"
              placeholder="Chapter Number"
              value={chapterNumber}
              onChange={(e) => setChapterNumber(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="mb-3">
            <input
              type="number"
              placeholder="Subchapter Number"
              value={subchapterNumber}
              onChange={(e) => setSubchapterNumber(e.target.value)}
              className="form-control"
            />
          </div>
          <div className="mb-3">
            <input
              type="number"
              placeholder="Image Number"
              value={imageNumber}
              onChange={(e) => setImageNumber(e.target.value)}
              className="form-control"
            />
          </div>

          <button
            onClick={handleFetch}
            disabled={loading}
            className="btn btn-primary w-100"
          >
            {loading ? "Loading..." : "Fetch Image"}
          </button>

          {error && <p className="text-danger mt-2">{error}</p>}
        </div>
      )}

      {/* Step 2: Editing section */}
      {subchapter && (
        <EditHotspotImage
          subchapter={subchapter}
          hotspots={hotspots}
          onChange={handleHotspotsChange}
          onSave={handleSave}
          saving={saving}
        />
      )}
    </div>
  );
}

// ==================== Edit Hotspot Image Section ====================
const EditHotspotImage = ({ subchapter, hotspots, onChange, onSave, saving }) => {
  return (
    <div className="card p-4 mt-4 shadow-sm">
      <h5 className="mb-3 text-center text-secondary">
        Editing Hotspots for: <strong>{subchapter.subchapterTitle}</strong>
      </h5>

      {/* 🔹 Centered image container */}
      <div className="d-flex justify-content-center align-items-center">
        <HotspotEditor
          imageUrl={`${baseURL}/${subchapter.content}`}
          hotspots={hotspots}
          onChange={onChange}
        />
      </div>

      <div className="text-center mt-3">
        <button
          onClick={onSave}
          disabled={saving}
          className="btn btn-success px-4"
        >
          {saving ? "Saving..." : "💾 Save Hotspots"}
        </button>
      </div>
    </div>
  );
};

// ==================== Hotspot Editor Section ====================
  const HotspotEditor = ({ imageUrl, hotspots, onChange }) => {
  const [localHotspots, setLocalHotspots] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null); // track which hotspot is being edited

  useEffect(() => {
    setLocalHotspots(hotspots || []);
  }, [hotspots]);

  const handleImageClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width).toFixed(2);
    const y = ((e.clientY - rect.top) / rect.height).toFixed(2);

    const newHotspot = {
      hotspotNumber: localHotspots.length + 1,
      label: `Hotspot ${localHotspots.length + 1}`,
      content: "Enter description",
      shape: "circle",
      coordinates: JSON.stringify([parseFloat(x), parseFloat(y)]),
    };
    const updated = [...localHotspots, newHotspot];
    setLocalHotspots(updated);
    onChange(updated);
    };
  const handleUpdateHotspot = (index, field, value) => {
    const updated = localHotspots.map((h, i) =>
      i === index ? { ...h, [field]: value, label: `Hotspot ${h.hotspotNumber}` } : h
    );
    setLocalHotspots(updated);
    onChange(updated);
  };

  const handleDeleteHotspot = (index) => {
    const updated = localHotspots.filter((_, i) => i !== index);
    setLocalHotspots(updated);
    onChange(updated);
    setActiveIndex(null);
  };

  const handleOutsideClick = (e) => {
    if (!e.target.closest(".hotspot-editor-popup")) {
      setActiveIndex(null);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);

  return (
    <div
      className="position-relative border rounded bg-light p-2"
      style={{ display: "inline-block", margin: "auto" }}
    >
      <img
        src={imageUrl}
        alt="Hotspot"
        className="img-fluid border"
        style={{
          maxWidth: "500px",
          height: "auto",
          cursor: "crosshair",
        }}
        onClick={handleImageClick}
      />

      {/* Render hotspots */}
      {localHotspots.map((h, i) => {
        let coords = [];
        try {
          coords = JSON.parse(h.coordinates || "[]");
        } catch {
          coords = [];
        }
        const [x = 0, y = 0] = coords;

        return (
          <div
            key={i}
            className="position-absolute"
            style={{
              top: `${y * 100}%`,
              left: `${x * 100}%`,
              transform: "translate(-50%, -50%)",
            }}
          >
            {/* 🔴 Dot */}
            <div
              className="bg-danger text-white rounded-circle d-flex align-items-center justify-content-center shadow"
              style={{
                width: "24px",
                height: "24px",
                fontSize: "12px",
                cursor: "pointer",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setActiveIndex(i);
              }}
              title={h.label}
            >
              {i + 1}
            </div>

            {/* ✏️ Floating editor for hotspot */}
           {activeIndex === i && (
  <div
    className="hotspot-editor-popup position-absolute bg-white p-3 border rounded shadow-lg"
    style={{
      top: "30px",
      left: "30px",
      width: "min(400px, 90vw)", // 🧠 responsive width
      zIndex: 999,
    }}
    onClick={(e) => e.stopPropagation()}
  >
    <div className="mb-2">
      <label className="form-label mb-1 fw-semibold">Hotspot #</label>
      <input
        type="number"
        className="form-control form-control-lg"
        value={h.hotspotNumber}
        onChange={(e) =>
          handleUpdateHotspot(i, "hotspotNumber", parseInt(e.target.value))
        }
        style={{
          fontSize: "1rem",
          padding: "10px",
        }}
      />
    </div>

    <div className="mb-2">
      <label className="form-label mb-1 fw-semibold">Content</label>
      <textarea
        className="form-control form-control-lg"
        rows="4"
        value={h.content}
        onChange={(e) => handleUpdateHotspot(i, "content", e.target.value)}
        style={{
          fontSize: "1rem",
          padding: "10px",
          resize: "vertical",
        }}
      />
    </div>

    <div className="d-flex justify-content-end">
      <button
        className="btn btn-danger btn-lg me-2"
        onClick={() => handleDeleteHotspot(i)}
      >
        🗑 Remove
      </button>
      <button
        className="btn btn-secondary btn-lg"
        onClick={() => setActiveIndex(null)}
      >
        ✖ Close
      </button>
    </div>
  </div>
)}

          </div>
        );
      })}
    </div>
  );
};
